import React, { useEffect } from "react";
import { Spinner } from '../utils/Spinner';
import { useSpinner } from "../../../hooks/useSpinner";
import Draggable from "react-draggable";



export const Modal = ({
    isOpen, 
    closeModal, 
    action, 
    width, 
    children, 
    title, 
    textButtons = { confirm: 'Guardar', denied: 'Cerrar', other: 'Nueva opción' }, 
    validButton = { confirm: true , denied: true, other: false },
	clasesModal = "",
    actionOtherButton,
}) => {
    const [ spinner, mostrarSpinner, ocultarSpinner ] = useSpinner(); 
    useEffect(() => {
        if(isOpen){
            const presionarTecla = (event) =>{
                if(event.keyCode === 27){
                    closeModal()
                }
            }
            document.addEventListener("keydown", presionarTecla);

            return () => {
                document.removeEventListener("keydown", presionarTecla);
            };
        }
    },[isOpen])
    return (
    <>  
        {isOpen ? (
            <>
                <Draggable handle="strong">
                    <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-[100] outline-none focus:outline-none">
                        <div
                            className={` ${clasesModal ? clasesModal : ''}  relative ${width ? width : ' w-auto '} lg:w-full my-6 mx-auto  max-w-[90%]`}
                            style={{boxShadow: 'rgb(0 0 0) 0px 0px 25px 8px'}}
                        >
                        {/*content*/}
                            <div className="bg-[#2d2f30] border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                                {/*header*/}
                                <strong>
                                    <div className="divMovibleCabecera bg-[#003478]  flex items-start justify-between p-5 border-b border-solid border-[#4e4e4e] rounded-t">
                                        <h3 className="text-xl font-semibold lg:text-sm w-[95%] whitespace-nowrap text-ellipsis overflow-hidden">
                                            {title}
                                        </h3>
                                        <button
                                            className="z-50 w-[5%]"
                                            onClick={closeModal}
                                            onTouchStart ={closeModal}
                                            >
                                            <i className="fas fa-times z-50"></i>
                                        </button>
                                    </div>
                                </strong>
                                {/*body*/}
                                <div className="lg:max-h-[550px] p-6 flex-auto bg-[#2f3134] lg:p-3">
                                    { children }
                                </div>
                                {/*footer*/}
                                <div className="bg-[#151616] flex items-center justify-end p-6 rounded-b">
                                {validButton.other ?
                                    <button
                                    className=" lg:text-xs left-2 lg:border lg:p-2 text-white-500 absolute hover:bg-green-800 rounded
                                        bg-green-600 font-bold capitalize
                                        px-6 py-2 text-sm outline-none focus:outline-none ease-linear transition-all duration-150 "
                                    type="button"
                                    onClick={async () =>{
                                        mostrarSpinner();
                                        await actionOtherButton();
                                        ocultarSpinner();
                                    }}
                                    
                                    >
                                        {
                                            spinner 
                                            ? <Spinner spinner={spinner.toString()}></Spinner>
                                            : <span>{textButtons.other}</span>
                                        }
                                    </button>
                                    : ''
                                }
                                {validButton.confirm ?
                                    <button
                                    className="  min-w-[100px] lg:min-w-[60px] bg-blue-500 hover:bg-blue-600 text-white active:bg-blue-600 font-bold capitalize text-sm lg:px-0 lg:py-0 px-4 py-2 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-xs"
                                    type="button"
                                        onClick={async () => {
                                            mostrarSpinner();
                                            await action();
                                            ocultarSpinner();
                                            // cerrarAlGuardar && closeModal()
                                        }}
                                    >
                                        <i className="fa fa-floppy-disk lg:block text-2xl hidden" ></i>
                                        {
                                            spinner 
                                            ? <Spinner spinner={spinner.toString()}></Spinner>
                                            : <span className="lg:hidden lg:w-1 ">{textButtons.confirm}</span>
                                        }
                                    </button>
                                    : ''
                                }
                                {validButton.denied ?
                                    <button
                                    className="bg-[#2f3134] text-white-500 hover:bg-stone-600 lg:bg-stone-600 lg:border lg:border-gray-500 rounded background-transparent font-bold capitalize lg:px-3 lg:py-0 px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-xs"
                                    type="button"
                                    onClick={closeModal}
                                    >
                                        <i className="fa fa-times text-red-500 lg:block text-2xl hidden" ></i>
                                        <span className="lg:hidden ">{textButtons.denied}</span>
                                    </button>
                                    : ''
                                }
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <div className="opacity-25 fixed inset-0 z-[1040] bg-black"></div> */}
                </Draggable>
            </>
        ) : null}
        </>
    );
}